import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { Autoplay, EffectFade } from 'swiper/modules';
import { Text } from '@portals/ui-kit';
import { DURATION_MS } from '@/_components/promo-zone/_components/card/_components/slider/_components/_constants';
import { BasketImage } from '@/_components/basket-image';
import { TSlide } from '../../_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Slider';

type TProps = {
  slides: Array<TSlide>;
};

export const Slider = ({ slides }: TProps) => {
  const translations = useTranslations();

  return (
    <div className={cn(BLOCK_NAME)}>
      <Swiper
        allowTouchMove={false}
        autoplay={{
          delay: DURATION_MS,
          disableOnInteraction: false,
          waitForTransition: true,
        }}
        className={cn(`${BLOCK_NAME}__content`)}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        loop
        modules={[Autoplay, EffectFade]}
        speed={500}
      >
        {slides.map(
          (
            {
              image,
              data: { name, organizationName, industry, corporateTitle },
            },
            index,
          ) => (
            <SwiperSlide key={index}>
              <div className={cn(`${BLOCK_NAME}__image-wrapper`)}>
                <BasketImage
                  alt="background"
                  fill
                  sizes="100%"
                  src={image}
                  style={{
                    objectFit: 'contain',
                    objectPosition: 'bottom',
                  }}
                />
              </div>
              <div
                className={cn(`${BLOCK_NAME}__info`, {
                  [`${BLOCK_NAME}__info-with-corporate-title`]:
                    !!corporateTitle,
                })}
              >
                <div className={cn(`${BLOCK_NAME}__name`)}>
                  <Text size="title-s" text={translations(name)} />
                </div>
                {corporateTitle && (
                  <div className={cn(`${BLOCK_NAME}__corporate-title`)}>
                    <Text size="title-s" text={translations(corporateTitle)} />
                  </div>
                )}
                <div>
                  <Text size="body-m" text={translations(organizationName)} />
                </div>
                {industry && (
                  <div>
                    <Text size="body-m" text={translations(industry)} />
                  </div>
                )}
              </div>
            </SwiperSlide>
          ),
        )}
      </Swiper>
    </div>
  );
};
